import '../styles/templates-common.css';
import { useEffect } from 'react';
import { PerfUtilService } from '../services/util/perf-util.service';
import { BrowserUtilService } from '../services/util/browser-util.service';
import { useSelector } from 'react-redux';

export const useBlockScroll = () => {
    const {
        isMobile,
    } = useSelector((state) => state.app);

    const preventScroll = PerfUtilService.debounce(BrowserUtilService.scrollToTop, 100);

    const blockScroll = () => {
        document.body.classList.add('asg-layout--blocked-scroll');

        // for mobile, as a fallback, we also return page to top on scroll
        // some older devices like iPhone 8, Android S10 still allow user to scroll
        // while having height 100vh and overflow hidden on body
        if (isMobile) {
            window.addEventListener('scroll', preventScroll);
        }
    };

    const unblockScroll = () => {
        document.body.classList.remove('asg-layout--blocked-scroll');
        window.removeEventListener('scroll', preventScroll);
    };

    useEffect(() => {
        return unblockScroll;
    }, []);

    return {
        blockScroll,
        unblockScroll,
    };
};
